<div class="textstotranslate page">
  @if (this.seances.length > 0) {
<div class="d-flex align-items-center justify-content-between mb-4">
    <div class="form-floating">
      <select class="select form-select" placeholder="">
        @for (seance of this.seances; track seance) {
<option
         
          value=""
          (click)="this.getPvsBySeance(seance.id)"
        >
          Traductions du
          {{ seance.date_creation | date : "dd/MM/yyyy" }}
        </option>
}
      </select>
      <label for="">Séance</label>
    </div>
  </div>
} @else {

    <div>
      Aucun texte à traduire pour le moment
    </div>
  
}
  
  <app-texts-list
    [textsList]="this.assignedTranslations"
    [todo]="this.textsTodo.TRANSLATE"
    (showTranslateDialogEvent)="this.onShowTranslateDialog($event.pv, $event.translatedText)"
  />

  <app-dialog
    #postDialog
    title="Envoyer la traduction"
    [visibility]="this.translateDialogVisible"
    (closeDialogEvent)="this.translateDialogVisible = $event"
  >

  <app-post-states
      [isPosting]="this.isPosting"
      [isPostingOver]="this.isPostingOver"
      [postError]="this.postError"
      readyMessage="Vous allez envoyer une traduction"
      postingMessage="La traduction est en cours d'envoi"
      completeMessage="La traduction a été envoyée avec succès"
    />

  <div dialog-footer>
      @if (!this.isPosting && !this.isPostingOver && !this.postError) {
<div>
        <button
          class="btn btn-danger me-2"
          (click)="postDialog.closeDialog()"
        >
          Annuler
        </button>
        <button
          class="btn btn-success"
          (click)="this.postTranslation()"
        >
          Valider
        </button>
      </div>
}
      @if (this.isPostingOver) {
<div>
        <button
          class="btn btn-success me-2"
          (click)="postDialog.closeDialog()"
        >
          Fermer
        </button>
      </div>
}
      @if (this.postError) {
<div>
        <button
          class="btn btn-danger me-2"
          (click)="postDialog.closeDialog()"
        >
          Fermer
        </button>
      </div>
}
    </div>
  </app-dialog>
</div>
